export default {"src":"/_next/static/media/cactus.51f1b49d.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};